import { Mail } from "lucide-react";
import { useState, useEffect } from "react";
import img1 from "Assets/Images/car_frame_1.jpg"
import img2 from "Assets/Images/car_frame_2.webp"
import img3 from "Assets/Images/car_frame_3.avif"

// ─── DATA ───────────────────────────────────────────────────────────────────

const cars = [
  {
    id: 0,
    frameLabel: "Frame 1707479167",
    headline: "Download Our App to Enjoy Unlimited Services",
    sub: "Our App Available in all Platforms",
    // Matching EditCabModal's red variant colors
    gradientFrom: "from-red-500",
    gradientTo: "to-rose-600",
    accentBg: "bg-red-50",
    accentBorder: "border-red-200",
    accentText: "text-red-700",
    badgeBg: "bg-red-100",
    dotBg: "bg-red-500",
    pillActive: "border-red-400",
    progressBg: "bg-red-500",
    imgBg: "bg-red-500",
    carImg: img1,
  },
  {
    id: 1,
    frameLabel: "Frame 1707479169",
    headline: "Experience the Future of Smart Driving",
    sub: "Available on iOS and Android",
    // Matching EditCabModal's green-600 to emerald-600 gradient
    gradientFrom: "from-green-600",
    gradientTo: "to-emerald-600",
    accentBg: "bg-green-50",
    accentBorder: "border-green-200",
    accentText: "text-green-700",
    badgeBg: "bg-green-100",
    dotBg: "bg-green-600",
    pillActive: "border-green-500",
    progressBg: "bg-green-600",
    imgBg: "bg-green-600",
    carImg: img2,
  },
  {
    id: 2,
    frameLabel: "Frame 1707479170",
    headline: "Book, Ride & Arrive in Pure Comfort",
    sub: "Seamless rides at your fingertips",
    // Blue variant
    gradientFrom: "from-blue-600",
    gradientTo: "to-sky-500",
    accentBg: "bg-blue-50",
    accentBorder: "border-blue-200",
    accentText: "text-blue-700",
    badgeBg: "bg-blue-100",
    dotBg: "bg-blue-600",
    pillActive: "border-blue-400",
    progressBg: "bg-blue-600",
    imgBg: "bg-blue-600",
    carImg: img3,
  },
];

// ─── GOOGLE PLAY BUTTON ──────────────────────────────────────────────────────
function GooglePlayBtn() {
  return (
    <button className="flex items-center gap-2 bg-gray-900 hover:bg-gray-700 text-white px-4 py-2.5 rounded-xl transition-colors duration-200 min-w-[130px]">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M3.18 23.76a2 2 0 001.73-.08l12.42-7.17-2.9-2.9L3.18 23.76z"
          fill="#EA4335"
        />
        <path
          d="M20.82 10.27L17.77 8.5 14.6 11.67l3.17 3.17 3.07-1.78a2 2 0 000-2.79z"
          fill="#FBBC04"
        />
        <path
          d="M3.18.24L14.6 11.67l2.9-2.9L4.91.32A2 2 0 003.18.24z"
          fill="#4285F4"
        />
        <path
          d="M3.18.24a2 2 0 00-1.18 1.8v19.92a2 2 0 001.18 1.8l11.42-11.44L3.18.24z"
          fill="#34A853"
        />
      </svg>
      <div className="text-left leading-tight">
        <div className="text-[9px] opacity-60 tracking-wide">GET IT ON</div>
        <div className="text-sm font-bold tracking-tight">Google Play</div>
      </div>
    </button>
  );
}

// ─── APP STORE BUTTON ────────────────────────────────────────────────────────
function AppStoreBtn() {
  return (
    <button className="flex items-center gap-2 bg-gray-900 hover:bg-gray-700 text-white px-4 py-2.5 rounded-xl transition-colors duration-200 min-w-[130px]">
      <svg width="16" height="20" viewBox="0 0 814 1000" fill="#fff">
        <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 376.1 0 248 0 123.3 0 55.1 22.5 13.7 59.4 13.7c29 0 65.5 31.6 65.5 31.6s-17.5 11.9-17.5 69.3c0 57.4 65 125 89.9 125 18.6 0 39.6-15.3 39.6-44.5 0-29.2-15.4-50.2-15.4-75.1 0-65 51.2-107.3 118.9-107.3 42.1 0 71.1 29.5 71.1 80.7 0 28.9-4.8 47-7.8 76.3 0 31.4 19.5 57.9 46.5 57.9 21.4 0 44.1-21.9 75.4-21.9 28.3 0 79.6 16.4 79.6 64.8 0 31.5-15.3 55.4-15.3 82.3 0 29.5 26.2 55.4 58.4 55.4 30.1 0 49.8-15 79.3-15 20.4 0 46.3 8.8 66.7 8.8 88.2 0 142.8-59.5 142.8-122.6z" />
      </svg>
      <div className="text-left leading-tight">
        <div className="text-[9px] opacity-60 tracking-wide">
          Download on the
        </div>
        <div className="text-sm font-bold tracking-tight">App Store</div>
      </div>
    </button>
  );
}

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
export default function CarHeroBanner() {
  const [current, setCurrent] = useState(1);
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(0);
  const [email, setEmail] = useState("");
  const car = cars[current];

  const goTo = (idx) => {
    if (idx === current) return;
    setVisible(false);
    setProgress(0);
    setTimeout(() => {
      setCurrent(idx);
      setTimeout(() => setVisible(true), 80);
    }, 260);
  };
  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Subscribing email:", email);
    // Add subscription logic here
    setEmail("");
  };
  useEffect(() => {
    setProgress(0);
    const DURATION = 3500;
    const TICK = 50;
    const step = 100 / (DURATION / TICK);
    const prog = setInterval(
      () => setProgress((p) => Math.min(p + step, 100)),
      TICK,
    );
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % cars.length);
        setProgress(0);
        setTimeout(() => setVisible(true), 80);
      }, 260);
    }, DURATION);
    return () => {
      clearTimeout(timer);
      clearInterval(prog);
    };
  }, [current]);

  useEffect(() => {
  cars.forEach((car) => {
    const img = new Image();
    img.src = car.carImg;
  });
}, []);

  return (
    <div className="w-full flex justify-center items-center px-4 sm:px-8 lg:px-20 py-10 bg-gray-100 min-h-[520px]">
      <div className="relative w-full  bg-white rounded-2xl shadow-2xl overflow-hidden ">
        {/* ── HEADER — matches EditCabModal's gradient header exactly ── */}
        <div
          className={`bg-gradient-to-r ${car.gradientFrom} ${car.gradientTo} p-6 flex justify-between items-center transition-all duration-500`}
        >
          <div
            className={`transition-all duration-300 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}
          >
            {/* Frame badge — like a modal sub-label */}
            <span className="inline-block text-xs font-semibold text-white/70 tracking-widest uppercase mb-1">
              {car.frameLabel}
            </span>
            <h2 className="text-xl font-bold text-white leading-snug max-w-md">
              {car.headline}
            </h2>
            <p className="text-sm text-white/70 mt-1">{car.sub}</p>
          </div>

          {/* Car image — top-right, rounded-xl like modal images */}
          <div
            className={`flex-shrink-0 w-52 h-36 rounded-xl overflow-hidden shadow-lg ml-6 transition-all duration-300 ${visible ? "opacity-100 translate-x-0 scale-100" : "opacity-0 translate-x-6 scale-95"}`}
          >
            <img
            key={car.id}
              src={car.carImg}
              loading="lazy"
              alt="car"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        {/* ── BODY — white section matching form body in EditCabModal ── */}
        <div className={`p-6 ${car.accentBg} transition-colors duration-500`}>
          {/* Info chips row — like the badge/tag pattern in modals */}
          <div
            className={`flex flex-wrap gap-3 mb-5 transition-all duration-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
          >
            {[
              { icon: "🚗", label: "Smart Vehicles" },
              { icon: "📍", label: "Real-time Tracking" },
              { icon: "⭐", label: "Top Rated Drivers" },
              { icon: "🛡️", label: "Safe & Secure" },
            ].map((chip) => (
              <span
                key={chip.label}
                className={`flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full border ${car.accentBorder} ${car.accentText} bg-white shadow-sm`}
              >
                <span>{chip.icon}</span>
                {chip.label}
              </span>
            ))}
          </div>

          {/* App store buttons row — like the action buttons in EditCabModal */}
          <div
            className={`flex gap-3 flex-wrap transition-all duration-300 delay-75 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
          >
            <GooglePlayBtn />
            <AppStoreBtn />
          </div>
        </div>
        {/* Email Input */}
        {/* <form onSubmit={handleSubscribe} className="relative">
                <div className="flex items-center bg-white rounded-full overflow-hidden shadow-lg">
                  <div className="pl-4 pr-2">
                    <Mail className="w-5 h-5 text-gray-400" />
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Email Address"
                    className="flex-1 py-3 px-2 text-gray-900 text-sm focus:outline-none"
                    required
                  />
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 font-semibold text-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300"
                  >
                    Subscribe
                  </button>
                </div>
              </form> */}
        {/* ── FOOTER — like the modal's action footer with border-t ── */}
        <div className="flex items-center gap-3 px-6 py-4 border-t border-gray-100 bg-white">
          {/* Frame selector pills — styled like modal cancel/submit buttons */}
          {cars.map((c, i) => (
            <button
              key={c.id}
              onClick={() => goTo(i)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-xl border-2 text-xs font-mono font-semibold transition-all duration-200 cursor-pointer
                ${
                  i === current
                    ? `bg-white ${c.pillActive} text-gray-800 shadow-md`
                    : "bg-gray-50 border-transparent text-gray-400 hover:bg-gray-100"
                }`}
            >
              <span className={`w-2 h-2 rounded-full ${c.dotBg}`} />
              {c.frameLabel.split(" ")[1]}
            </button>
          ))}

          {/* Progress bar — like a loading indicator */}
          <div className="flex-1 ml-2 h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full ${car.progressBg} transition-none`}
              style={{
                width: `${progress}%`,
                transition: "width 0.05s linear",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
